var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 53.454,
    y1: 18.8,
    x2: 53.454,
    y2: 99.609,
    id: "gradient-0",
    gradientTransform: "matrix(0.806497, -0.591238, 0.138655, 0.189136, -3.467712, 112.373321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(160, 160, 160)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgba(135, 165, 36, 1)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 81.17,
    y1: 18.8,
    x2: 81.17,
    y2: 77.89,
    id: "gradient-1",
    gradientTransform: "matrix(0.764376, 0.64477, -0.110047, 0.130461, 27.697124, 15.392402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(99, 99, 99)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgba(135, 165, 36, 1)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -228.746246, 88.247871)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.067342, 0, 0, 4.067342, 199.65358, -79.587013)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.7,77L97.9,18.8L42.6,29l76.1,48.8C119.3,78.1,119.9,77.6,119.7,77z",
    style: {
      paintOrder: "fill",
      fillRule: "nonzero",
      fill: "url(#gradient-1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.9,18.8",
    style: {
      opacity: 0.55,
      paintOrder: "fill",
      fillRule: "nonzero",
      fill: "rgb(186, 218, 85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.1,98.4L42.6,29l55.3-10.2L10.4,99.4C9.7,100,8.7,99.2,9.1,98.4z",
    style: {
      opacity: 0.85,
      paintOrder: "fill",
      fillRule: "nonzero",
      fill: "url(#gradient-0)"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRv);
export default __webpack_public_path__ + "static/media/RV.9c356c9c3fb3320f38168fe7fcd0e860.svg";
export { ForwardRef as ReactComponent };